/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamAnswerAiCorrectionBatchMutationRequest,
  PostApiV1ExamAnswerAiCorrectionBatchMutationResponse,
  PostApiV1ExamAnswerAiCorrectionBatch400,
  PostApiV1ExamAnswerAiCorrectionBatch401,
  PostApiV1ExamAnswerAiCorrectionBatch500,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamAnswerAiCorrectionBatch.ts";

function getPostApiV1ExamAnswerAiCorrectionBatchUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/exam/answer/ai-correction-batch` as const,
  };
  return res;
}

/**
 * @description Solicita ao modelo de IA (Gemini) a correção de múltiplas respostas em uma única chamada, com base nos dados cadastrados em cada questão.
 * Respostas que forem automaticamente **ignoradas** (sem erro, apenas puladas):
 * - Questão não encontrada ou resposta do aluno vazia.
 * - Componente não suportado (apenas SingleLineText e MultilineText são corrigidos por IA).
 * - Subtipo **ModelAnswerEssay** sem `ModelAnswer` ou sem `KeyTerms` cadastrados.
 * - Subtipo **MbaCase** sem `ModelAnswer` (Notas de Ensino) cadastrado.
 * Para os demais, a estratégia de correção segue o subtipo configurado na questão:
 * - **OpinionArticle** (1): avalia tese, argumentação e conclusão.
 * - **Essay** (2): avalia conteúdo, completude, coesão e gramática.
 * - **ModelAnswerEssay** (3): compara à resposta-modelo e verifica os termos-chave.
 * - **MbaCase** (4): avalia à luz das Notas de Ensino.
 * Retorna apenas as respostas efetivamente corrigidas. Respostas puladas não aparecem no array de retorno. **(Requer Authorization para autenticação)**
 * @summary Correção em lote de questões dissertativas por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/answer/ai-correction-batch}
 */
export async function postApiV1ExamAnswerAiCorrectionBatch(
  data?: PostApiV1ExamAnswerAiCorrectionBatchMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ExamAnswerAiCorrectionBatchMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamAnswerAiCorrectionBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamAnswerAiCorrectionBatch400
      | PostApiV1ExamAnswerAiCorrectionBatch401
      | PostApiV1ExamAnswerAiCorrectionBatch500
    >,
    PostApiV1ExamAnswerAiCorrectionBatchMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamAnswerAiCorrectionBatchUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
